@let allTemplatesValue = allTemplates();

@if (!allTemplatesValue.length) {
  <div layout-vertical padding-large layout-justify-center layout-align-items-center margin-large>
    <rt-heading variant="heading" margin-bottom-small-x>
      {{ translations().interview.emptyTemplateTitle | translate }}
    </rt-heading>
    <rt-heading variant="subheading" margin-bottom>
      {{ translations().interview.emptyTemplateDescription | translate }}
    </rt-heading>
  </div>
}

@if (allTemplatesValue.length) {
  <form [formGroup]="form">
    @if (hasOffers() && !schedule) {
      <rt-form-field
        [class.hidden]="!hasMoreThanOneOffer()"
        [attr.margin]="!schedule"
        [attr.margin-lr]="schedule"
        [attr.margin-top-small]="schedule"
        [attr.margin-bottom-small-xx]="schedule"
      >
        <rt-label>
          {{ this.translations().interview.job | translate }}
        </rt-label>
        <rt-offer-select
          [formControl]="$any(form.get('offerId'))"
          [offers]="offers()"
          [hasSearch]="false"
          [hasInputTrigger]="true"
          [placeholder]="translations().interview.jobPlaceholder | translate"
          [includeEmptyOption]="false"
        />
      </rt-form-field>
    }

    <rt-form-field [required]="!form.get('templateId')?.value" margin>
      <rt-label>
        {{ translations().interview.template | translate }}
      </rt-label>
      <rt-select
        [hasInputTrigger]="true"
        [groupedOptions]="visibleTemplates()"
        [disabled]="!templatesLoaded()"
        [includeEmptyOption]="false"
        [searchPlaceholder]="'app.common.placeholders.search.forms.other' | translate"
        [placeholder]="translations().interview.templatePlaceholder | translate"
        [optionTemplate]="optionTemplate"
        formControlName="templateId"
        class="template-select"
      />
      @if (form.get('templateId')?.dirty && form.get('templateId')?.invalid) {
        <span text-red padding-top-small-xx>{{ translations()?.interview?.required }}</span>
      }
      <ng-template #optionTemplate let-option="option">
        <div>
          <span margin-right-small-x>{{ option.label }}</span>
          @if (option.badgeText) {
            <rt-badge [text]="option.badgeText" [color]="'optional'" flex />
          }
        </div>
      </ng-template>
    </rt-form-field>

    <rt-form-field
      [required]="!form.get('admins')!.value.length"
      [attr.margin]="!schedule"
      [attr.margin-lr]="schedule"
      [attr.margin-top-small]="schedule"
      [attr.margin-bottom-small-xx]="schedule"
    >
      <rt-label>
        {{ translations().interview.scheduleDialog.requestFrom | translate }}
      </rt-label>
      <div layout>
        @if (admins()) {
          <rt-admins-avatars
            [admins]="form.get('admins')!.value"
            [editable]="canViewCandidates"
            [limit]="5"
            (addClick)="editAssignments()"
            (avatarsClick)="editAssignments()"
            variant="rtl"
            margin-top-small-x
          />
        }
      </div>
    </rt-form-field>
  </form>
  <rt-divider variant="line" margin-top />
  <div layout-horizontal layout-justify-flex-end layout-align-items-center>
    <rt-group margin-lr margin-tb-medium layout-justify-flex-end>
      <rt-button (click)="close.emit()" variant="plain">
        {{ translations().interview.cancel | translate }}
      </rt-button>
      <rt-button
        [disabled]="!form.get('admins')!.value.length || !form.get('templateId')?.value"
        (click)="requestInterview()"
        variant="primary"
      >
        {{
          (schedule
            ? translations().interview.scheduleDialog.add
            : translations().interview.requestNow
          ) | translate
        }}
      </rt-button>
    </rt-group>
  </div>
}
